import auth0 from 'auth0-js'
//import { AUTH_CONFIG } from './auth0-variables'
import EventEmitter from 'eventemitter3'
import router from '@/router/router.js'

export default class AuthService {
    authenticated = this.isAuthenticated()
    authNotifier = new EventEmitter()

    constructor(auth0Domain, auth0ClientId, auth0RedirectUri,
        auth0Audience, auth0ResponseType, auth0Scope) {
        this.login = this.login.bind(this)
        this.setSession = this.setSession.bind(this)
        this.logout = this.logout.bind(this)
        this.isAuthenticated = this.isAuthenticated.bind(this)
        this.getAccessToken = this.getAccessToken.bind(this)

        this.auth0 = new auth0.WebAuth({
            domain: auth0Domain,
            clientID: auth0ClientId,
            redirectUri: auth0RedirectUri,
            audience: auth0Audience,
            responseType: auth0ResponseType,
            scope: auth0Scope,
        })
    }



    login() {
        //console.log(AUTH0_REDIRECTURI);
        this.auth0.authorize()
    }

    handleAuthentication() {
        this.auth0.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken) {
                this.setSession(authResult)
                    // TODO: Make this a Promise
                router.push({
                    name: "SelectPartner",
                })
            } else if (err) {
                router.push({ name: "Error" })
                console.log(err)
            }
        })
    }

    async refreshToken() {
        let expiry = localStorage.getItem('expires_at')
        let now = Date.now()
        let that = this;

        // check if token expires in less than 30 minutes,
        // or has already expired
        return new Promise((resolve, reject) => {
            if (now > expiry - 1800000) {
                this.auth0.checkSession({}, function(err, authResult) {
                    if (err) {
                        throw new Error("Token has expired.")
                        return;
                    }
                    that.setSession(authResult);
                    resolve();
                });
            } else { resolve(); }
        });
    }

    setSession(authResult) {
        // Set the time that the Access Token will expire at
        let expiresAt = JSON.stringify(
            authResult.expiresIn * 1000 + new Date().getTime()
        )
        localStorage.setItem('access_token', authResult.accessToken)
        localStorage.setItem('id_token', authResult.idToken)
        localStorage.setItem('expires_at', expiresAt)
        this.authNotifier.emit('authChange', { authenticated: true })
    }

    logout() {
        // Clear Access Token and ID Token from local storage
        localStorage.removeItem('access_token')
        localStorage.removeItem('id_token')
        localStorage.removeItem('expires_at')
        this.userProfile = null
        this.authNotifier.emit('authChange', false)
    }

    isAuthenticated() {
        // Check whether the current time is past the
        // Access Token's expiry time
        let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
        return new Date().getTime() < expiresAt
    }

    getAccessToken() {
        let token = localStorage.getItem('access_token')
        return token
    }
}